import { render, staticRenderFns } from "./side.vue?vue&type=template&id=92052fa6"
import script from "./side.vue?vue&type=script&lang=js"
export * from "./side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports